import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import kapital from "@baseImg/media/kapital.svg";
import forbes from "@baseImg/media/forbes.svg";
import devbg from "@baseImg/media/devbg.svg";

const BG = {
	blockTitle: 'Superhosting в медиите',
	allText: '',
	blockContent: [
		{
			title: `
				   <a href="https://www.capital.bg/biznes/tehnologii_i_nauka/2024/03/15/4594532_kiberhigienata_iziskva_politika_na_nulevo_doverie_kum/" target="_blank">
				   		Киберхигиената изисква политика на нулево доверие към всеки имейл
				   </a>
				   `,
			name: 'Капитал',
			img: kapital
		},
		{
			title: `
				   <a href="https://forbesbulgaria.com/2024/06/24/perfektniyat-hosting-e-samo-nachaloto/" target="_blank">
				   		Перфектният хостинг е само началото
				   </a>
				   `,
			name: 'Forbes',
			img: forbes
		},
		{
			title: `
				   <a href="https://dev.bg/digest/superhosting-itw-dimitur-milushev-dc04/" target="_blank">
				   		Димитър Милушев, СуперХостинг.БГ: Инвестицията в хората и екипа винаги си струва
				   </a>
				   `,
			name: 'Dev.bg',
			img: devbg
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: 'Superhosting in the media',
	allText: '',
	blockContent: [
		{
			title: `
				   <a href="https://www.capital.bg/biznes/tehnologii_i_nauka/2024/03/15/4594532_kiberhigienata_iziskva_politika_na_nulevo_doverie_kum/" target="_blank">
				   		Cyber hygiene requires a zero-trust policy for every email
				   </a>
				   `,
			name: 'Capital',
			img: kapital
		},
		{
			title: `
				   <a href="https://forbesbulgaria.com/2024/06/24/perfektniyat-hosting-e-samo-nachaloto/" target="_blank">
				   		Perfect hosting is just the beginning
				   </a>
				   `,
			name: 'Forbes',
			img: forbes
		},
		{
			title: `
				   <a href="https://dev.bg/digest/superhosting-itw-dimitur-milushev-dc04/" target="_blank">
				   		Dimitar Milushev, SuperHosting.BG: Investing in people and teams is always worth it
				   </a>
				   `,
			name: 'Dev.bg',
			img: devbg
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];